import { render, staticRenderFns } from "./VltBrand.vue?vue&type=template&id=1a31df96&scoped=true&"
import script from "./VltBrand.vue?vue&type=script&lang=js&"
export * from "./VltBrand.vue?vue&type=script&lang=js&"
import style0 from "./VltBrand.vue?vue&type=style&index=0&id=1a31df96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a31df96",
  null
  
)

export default component.exports